import { render, staticRenderFns } from "./fileloader.vue?vue&type=template&id=2e5ed1c1&scoped=true&"
import script from "./fileloader.vue?vue&type=script&lang=js&"
export * from "./fileloader.vue?vue&type=script&lang=js&"
import style0 from "./fileloader.vue?vue&type=style&index=0&id=2e5ed1c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ed1c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5ed1c1')) {
      api.createRecord('2e5ed1c1', component.options)
    } else {
      api.reload('2e5ed1c1', component.options)
    }
    module.hot.accept("./fileloader.vue?vue&type=template&id=2e5ed1c1&scoped=true&", function () {
      api.rerender('2e5ed1c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/file_loader/fileloader.vue"
export default component.exports